<div>
    <mat-expansion-panel class="expansion-p send-report" *ngIf="showSendReport">
        <mat-expansion-panel-header>
            <mat-panel-title class="color-primary">
                <mat-icon>email</mat-icon><span class="ml-2 text-bold">Enviar reporte</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
            <div class="col-10">
                <app-select-company [options]="optionsCompany" [inputFormControl]="companyToOperations"
                    [validate]="validateToOperations">
                </app-select-company>
            </div>
            <div class="col-2 d-flex align-items-center justify-content-center">
                <mat-icon class="cursor-pointer color-primary ml-2" (click)="sendReport()">send</mat-icon>
            </div>
        </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="expansion-p" *ngIf="showOperations">
        <mat-expansion-panel-header>
            <mat-panel-title class="color-primary text-bold text-center">
                Operaciones
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
            <!--Totals div-->
            <div class="col-12">
                <span *ngIf="canPayTravelExpenses">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueTravelExpensesByType |currency:'COP':'code'):'0 COP'}}
                </span>
                <span *ngIf="canFulfillRndc">
                    Servicios seleccionados: {{itemsSelecteds.length}}
                </span>
                <span *ngIf="typePaymentByTab==='balance'||canApproveCargos">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueBalanceCargos | currency:'COP':'code'):'0 COP'}}
                    <span *ngIf="typePaymentByTab==='balance' && totalAdditionalStandBy > 0">
                        , Total adicionales({{totalAdditionalStandBy}}):
                        {{totalAdditionalCostsStandBy|currency:'COP':'code'}}
                    </span>
                </span>
                <span *ngIf="typePaymentByTab==='advance'">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueAdvanceCargos | currency:'COP':'code'):'0 COP'}}
                    <span *ngIf="totalAdditionals > 0">
                        , Total adicionales({{totalAdditionals}}): {{totalAdditionalCosts|currency:'COP':'code'}}
                    </span>
                </span>
                <span *ngIf="typePaymentByTab==='extraAdvance'">
                    Saldo restante({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueBalanceCargos | currency:'COP':'code'):'0 COP'}}
                </span>
                <span *ngIf="canConfirmCargo">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueRateCargos | currency:'COP':'code'):'0 COP'}}
                </span>
                <span
                    *ngIf="typeList==='paymentAdditionalCostsCargo'&& staticFilters['additionalCost']==='Servicio cargue'">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueUploadCargos | currency:'COP':'code'):'0 COP'}}
                </span>
                <span
                    *ngIf="typeList==='paymentAdditionalCostsCargo'&& staticFilters['additionalCost']==='Servicio descargue'">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueDownloadCargos | currency:'COP':'code'):'0 COP'}}
                </span>
                <span *ngIf="typeList==='paymentAdditionalCostsCargo'&& staticFilters['additionalCost']==='Stand by'">
                    Total seleccionado({{itemsSelecteds.length}}):
                    {{itemsSelecteds.length?(totalValueStandByCargos | currency:'COP':'code'):'0 COP'}}
                </span>
                <!-- <span *ngIf="typeList==='withoutPayment'">
                    Número de seleccionados: {{itemsSelecteds.length}}
                </span> -->
            </div>
            <div class="col-12"
                *ngIf="canConfirmCargoPayment || canConfirmEntryPayment || canModifyBill || canModifyVoucher">
                <app-select-company [options]="optionsCompany" [inputFormControl]="companyToOperations"
                    [validate]="validateToOperations">
                </app-select-company>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}" *ngIf="isCargoPayment"
                (click)="openModalPaymentCargo()">
                <i class="fas fa-check-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">
                    Pagar servicios
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}" *ngIf="canPayTravelExpenses"
                (click)="openModalPaymentTravelExpenses()">
                <i class="fas fa-check-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">
                    Pagar viáticos
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="isCargoPayment"
                (click)="openModalMassivePaymentCargo()">
                <img class="my-2" src="../../../assets/general-icons/double-check.png" alt="Double check">
                <div class="text-bold underline">Pagar servicios masivamente</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}" *ngIf="canConfirmCargoPayment"
                (click)="openModalCashedCargo('bill')">
                <i class="fas fa-check-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Confirmar cobro de servicios
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canConfirmCargoPayment" (click)="openModalCashedCargoMassive('bill')">
                <img src="../../../assets/general-icons/double-check.png" alt="Double check">
                <div class="text-bold underline">Confirmar cobro masivamente
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canConfirmCargoPayment" (click)="openDialogBillByPreBill()">
                <i class="fas fa-file-invoice my-2 color-primary"></i>
                <div class="text-bold underline">Confirmar cobro por Prefactura
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}" *ngIf="canConfirmEntryPayment"
                (click)="openModalCashedCargo('income')">
                <i class="fas fa-check-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Confirmar ingreso de servicios
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canConfirmEntryPayment" (click)="openModalCashedCargoMassive('income')">
                <img src="../../../assets/general-icons/double-check.png" alt="Double check">
                <div class="text-bold underline">Confirmar ingreso masivamente
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Approved'" (click)="approveCargosMassive(true)">
                <i class="fas fa-check-circle my-2 color-primary"></i>
                <div class="text-bold underline">Aprobar servicios masivamente</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Approved'"
                (click)="approveCargosByLicensePlate(true)">
                <i class="fas fa-car my-2 color-primary"></i>
                <div class="text-bold underline">Aprobar servicios por placa</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Approved'"
                (click)="approveOrDisapproveCargo(true)"
                [ngClass]="{'disabled-option':!itemsSelecteds.length || !isSomeCargosToApprove().canProceed}">
                <i class="fas fa-check-circle my-2"
                    [ngClass]="{'color-primary':itemsSelecteds.length && isSomeCargosToApprove().canProceed}"></i>
                <div class="text-bold"
                    [ngClass]="{'underline': itemsSelecteds.length && isSomeCargosToApprove().canProceed}">Aprobar
                    servicios</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Rejected'"
                (click)="approveCargosMassive(false)">
                <i class="fas fa-times-circle my-2 color-primary"></i>
                <div class="text-bold underline">Rechazar servicios masivamente</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Rejected'"
                (click)="approveCargosByLicensePlate(false)">
                <i class="fas fa-car my-2 color-primary"></i>
                <div class="text-bold underline">Rechazar servicios por placa</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Rejected'"
                (click)="approveOrDisapproveCargo(false)"
                [ngClass]="{'disabled-option':!itemsSelecteds.length || !isSomeCargosToDisapprove().canProceed}">
                <i class="fas fa-times-circle my-2"
                    [ngClass]="{'color-primary':itemsSelecteds.length && isSomeCargosToDisapprove().canProceed}"></i>
                <div class="text-bold"
                    [ngClass]="{'underline': itemsSelecteds.length && isSomeCargosToDisapprove().canProceed}">Rechazar
                    servicios</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Pending approval'"
                (click)="reverseCargosMassive()">
                <i class="fas fa-undo my-2 color-primary"></i>
                <div class="text-bold underline">Reversar servicios masivamente</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Pending approval'"
                (click)="reverseCargosByLicensePlate()">
                <i class="fas fa-car my-2 color-primary"></i>
                <div class="text-bold underline">Reversar servicios por placa</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canApproveCargos && staticFilters['approval']!=='Pending approval'" (click)="reverseCargos()"
                [ngClass]="{'disabled-option':!itemsSelecteds.length || !isSomeCargosToReverse().canProceed}">
                <i class="fas fa-undo my-2"
                    [ngClass]="{'color-primary':itemsSelecteds.length && isSomeCargosToReverse().canProceed}"></i>
                <div class="text-bold"
                    [ngClass]="{'underline': itemsSelecteds.length && isSomeCargosToReverse().canProceed}">
                    Reversar {{staticFilters['approval']==='Approved' ? 'aprobación' :
                    staticFilters['approval']==='Rejected' ? 'rechazo' : 'aprobación/rechazo'}} de servicios
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="canFulfillRndc"
                (click)="fulfillCargosRndcMassive()">
                <i class="fas fa-check-circle my-2 color-primary"></i>
                <div class="text-bold underline">Cumplir servicios masivamente</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="canFulfillRndc"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}" (click)="fulFillCargosRndc()">
                <i class="fas fa-check-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Cumplir servicios</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="canModifyBill"
                (click)="openDialogEdit('bill', 'facturas')" [ngClass]="{'disabled-option':!itemsSelecteds.length}">
                <i class="fas fa-cog my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Modificar factura(s)</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="canModifyBill"
                (click)="confirmDisassociate('bill', 'facturas')"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}">
                <i class="fas fa-minus-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Desasociar factura(s)</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="canModifyVoucher"
                (click)="openDialogEdit('income', 'comprobantes')"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}">
                <i class="fas fa-cog my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Modificar comprobante(s)</div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer" *ngIf="canModifyVoucher"
                (click)="confirmDisassociate('income', 'comprobantes')"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}">
                <i class="fas fa-minus-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Desasociar comprobante(s)</div>
            </div>

            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canGenerateJournal" (click)="confirmGenerateJournal()">
                <i class="fas fa-minus-circle my-2 color-primary"></i>
                <div class="text-bold underline">Generar Comprobantes Contables
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                *ngIf="canGenerateJournal" (click)="generateJournalByItemsSelected()"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}">
                <i class="fas fa-minus-circle my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">Generar Comprobantes
                    ({{itemsSelecteds.length}})
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                [ngClass]="{'disabled-option':!itemsSelecteds.length}" *ngIf="canMoveAdvance"
                (click)="openModalMoveAdvance()">
                <i class="fas fa-arrow-right my-2" [ngClass]="{'color-primary':itemsSelecteds.length}"></i>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">
                    Trasladar anticipos
                </div>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-start cursor-pointer"
                [ngClass]="{'disabled-option':!itemsSelecteds.length || !canPayWithLoggiCash.canPay}"
                *ngIf="canPayAdvance || (canPayBalance && filters.includes('fastPayment=true'))"
                (click)="openModalPaymentCargo('fintech')">
                <div class="loggicash-icon mr-1 my-2" [style.color]="itemsSelecteds.length ? '#02d7dc' : '#808080'"
                    [style.border-color]="itemsSelecteds.length ? '#02d7dc' : '#808080'">C</div>
                <div class="text-bold" [ngClass]="{'underline': itemsSelecteds.length}">
                    Pagar servicios con LoggiCash
                </div>
            </div>
        </div>
    </mat-expansion-panel>
    <div *ngIf="showSingleBillingXML" class="xml-button cursor-pointer" (click)="openDialogBillXML()">
        <i class="fas fa-plus-circle mr-2"></i> Cargar XML - Ministerio de Transporte
    </div>
    <ng-container *ngIf="showUploadsMenu">
        <div class="uploads-button cursor-pointer" [matMenuTriggerFor]="uploadsMenu">
            <i class="fas fa-plus-circle mr-2"></i>
            <span>Cargar archivos</span>
            <i class="fas fa-chevron-down ml-2"></i>
        </div>
        <mat-menu #uploadsMenu="matMenu" class="uploads-menu">
            <button mat-menu-item type="button" (click)="openDialogCashReceipts()">
                <i class="fas fa-file-excel mr-2"></i>
                <span>Cargar recibos de caja</span>
            </button>
            <button mat-menu-item type="button" (click)="openDialogCreditNoteAssociation()">
                <i class="fas fa-link mr-2"></i>
                <span>Asociar notas crédito</span>
            </button>
            <button mat-menu-item type="button" (click)="openDialogBillXML()">
                <i class="fas fa-file-code mr-2"></i>
                <span>Cargar XML - Ministerio de Transporte</span>
            </button>
        </mat-menu>
    </ng-container>
</div>